import http from "../http-common";

// import httpMultipart from "../http-multipart";

class ShiftMaster {
    createShift(data) {
        return http.post(`/shifts/create`, data);
    }

    getAllShifts(isActive, teamType, targetType, name, page, limit) {
        return http.get(`/shifts/search`, {params: {isActive, teamType, targetType, name, page, limit}});
    }

    updateShift(id, data) {
        return http.put(`/shifts/update/${id}`, data);
    }
    getShift(id) {
        return http.get(`/shifts/${id}`);
    }

    deleteShift(id) {
        return http.delete(`/shifts/delete/${id}`);
    }

    getShiftAssignments(teamName, teamType, pageNumber, maxPageItem) {
        return http.get(`/shift-management/team-assignments`, {params: {teamName, teamType, pageNumber, maxPageItem}});
    }

    getAllShiftsForTeam(teamId, teamType, pageNumber, maxPageItem) {
        return http.get(`/shifts/search-for-team`, {params: {teamId, teamType, pageNumber, maxPageItem}});
    }

    createTeamShiftAssignments(data) {
        return http.post(`/shift-management/team-assignments/create-for-team`, data);
    }

    getShiftAssignmentsByTarget(teamId, teamType, targetType, pageNumber, maxPageItem) {
        return http.get(`/shift-management/assignments`, {params: {teamId, teamType, targetType, pageNumber, maxPageItem}});
    }

    createShiftAssignments(data) {
        return http.post(`/shift-management/team-assignments/create`, data);
    }

    searchAttendanceRecord(teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem) {
        return http.get(`/attendance-record/search`, {params: {teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem}});
    }

    saveAttendanceRecord(data) {
        return http.post(`/attendance-record/save`, data);
    }

    saveAttendanceRecordOne(data) {
        return http.post(`/attendance-record/save-one`, data);
    }

    searchHistoryUpdateAttendance(recordId){
        return http.get(`/attendance-history/search`,{params: {recordId}})
    }

    getDailyExel(teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem) {
        return http.get(`/attendance-record/get-daily-excel`, {params: {teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem}});
    }
    getMonthlyExel(teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem) {
        return http.get(`/attendance-record/get-monthly-excel`, {params: {teamId, teamType, targetType, attendanceRecordDate, kidStatus, pageNumber, maxPageItem}});
    }

    getSummaryExel(teamId, teamType, targetType, startDate, endDate, kidStatus) {
        return http.get(`/attendance-record/get-summary-excel`, {params: {teamId, teamType, targetType, startDate, endDate, kidStatus}});
    }

    searchEatDate(teamId, teamType, targetType, attendanceRecordDate, pageNumber, maxPageItem) {
        return http.get(`/attendance-record/search/eat`, {params: {teamId, teamType, targetType, attendanceRecordDate, pageNumber, maxPageItem}});
    }
    saveOrUpdateListAttendanceEat(data){
        return http.post(`/attendance-record/eat/save-or-update-many`, data);
    }
}

export default new ShiftMaster();